<template>
  <component 
    :is="tag"
    :class="`${background} icon-container`"
    class="text-white d-flex justify-content-center align-items-center"
  >
    <i :class="icon" />
  </component>
</template>

<script>

export default {
  props: {
    background: {
      type: String,
      default: 'bg-gray-400'
    },
    icon: {
      type: String,
      default: 'fas fa-lock'
    },
    tag : {
      type: String,
      default: 'button'
    }
  },
}
</script>
<style lang="scss" scoped>
  .icon-container {
    width: 18px;
    height: 18px;
    border-radius: 9px;
    font-size: 0.6rem;
  }
</style>
